import styled from '@emotion/styled';
import { breakpoints, Fonts, Spacings } from '@styles/index';
import { useEffect, useState } from 'react';
import useBatchDetails from '@api/hooks/batch/useBatchDetails';
import PropTypes from 'prop-types';
import { useIsMobile } from '@stores/AppCommonData';
import { textTruncate } from '@utils/textHelper';

const DescriptionWrapper = styled.div`
  margin-top: ${Spacings.SPACING_2B};
  @media only screen and (max-width: ${breakpoints.mobile}) {
    margin: ${Spacings.SPACING_3B} 0 ${Spacings.SPACING_4B};
  }
`;
const CourseDescription = styled.span`
  font-weight: ${Fonts.REGULAR};
  font-size: ${Fonts.P1};
  line-height: ${Fonts.HEADER_LINE_HEIGHT};
  margin: ${Spacings.SPACING_0B};
  transition: all 300ms ease;
  color: var(--color-text-secondary);
  @media only screen and (max-width: ${breakpoints.mobile}) {
    font-size: ${Fonts.SMALL};
  }
`;

const ReadMore = styled.span`
  font-weight: ${Fonts.SEMIBOLD};
  font-size: ${Fonts.P1};
  line-height: ${Fonts.HEADER_LINE_HEIGHT};
  margin: ${Spacings.SPACING_0B};
  transition: all 300ms ease;
  margin-top: ${Spacings.SPACING_8B};
  cursor: pointer;
`;

const BatchDescription = ({ batchUID }) => {
  const { batchDetails } = useBatchDetails(batchUID);
  const isMobile = useIsMobile();
  const { description } = batchDetails || {};

  const [minTextLength, setMinTextLength] = useState(450);
  const [expandText, setExpandText] = useState(false);

  useEffect(() => {
    const textLength = isMobile ? 140 : 450;
    setMinTextLength(textLength);
  }, [isMobile]);

  const handleReadMore = () => {
    setExpandText(true);
  };

  return (
    <>
      <DescriptionWrapper>
        <CourseDescription>
          {expandText ? description : textTruncate(description, minTextLength)}
        </CourseDescription>
        {!expandText && description?.length > minTextLength && (
          <ReadMore onClick={handleReadMore}> Read more</ReadMore>
        )}
      </DescriptionWrapper>
    </>
  );
};

export default BatchDescription;

BatchDescription.propTypes = {
  batchUID: PropTypes.string.isRequired
};
